import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, useParams, useNavigate } from "react-router-dom";

import LoadingSpinner from '../partials/LoadingSpinner';
import PageHeader from '../partials/PageHeader';


import AddSupplierAssignmentModal from './AddSupplierAssignmentModal';
import UpdateSupplierAssignmentModal from './UpdateSupplierAssignmentModal';
import DeleteSupplierAssignmentModal from './DeleteSupplierAssignmentModal';

import { purchaseOrdersCreate, purchaseOrderAddItem, purchaseOrderUpdateQuantity } from '../../redux/actions/purchaseOrders';
import { reset } from '../../redux/actions/purchaseOrderLines';
import { suppliersIndex } from '../../redux/actions/suppliers';
import { taxSettingsIndex } from '../../redux/actions/taxSettings';
import { paymentTermsIndex } from '../../redux/actions/paymentTerms';
import { paymentMethodsIndex } from '../../redux/actions/paymentMethods';
// import { locationsIndex } from '../../redux/actions/locations';

import { findSuggestedPurchaseOrder, markComplete } from '../../redux/actions/suggestedPurchaseOrders';


// import AssignmentList from './AssignmentList';
// import ProductSearch from './ProductSearch';
// import ProductScan from './ProductScan';
import PurchaseOrderLine from './PurchaseOrderLine';
import PurchaseOrderTotals from './PurchaseOrderTotals';

const NewSuggestedPurchaseOrderForm = ({ 
  payload,
  newPurchaseOrder,
  taxSettings,
  paymentTerms,
  paymentMethods,
  accounts,
  suppliers,
  products,
  loadTaxSettings,
  loadPaymentTerms,
  loadPaymentMethods,
  loadSuppliers,
  // locations,
  // loadLocations,
  loadSuggestedOrder,
  addPurchaseOrder,
  purchaseOrderLines,
  activeSuggestedPurchaseOrder,
  incompleteOrders,
  clearPOLines,
  addItem,
  quantityUpdate,
  markSuggestionComplete,
  settings
 }) => {
  const { suggestedOrderId } = useParams();

  let navigate = useNavigate();

  const [activeSupplier, setActiveSupplier] = useState(null);
  const [activePaymentTerm, setActivePaymentTerm] = useState(null);
  const [activePaymentMethod, setActivePaymentMethod] = useState(null);
  const [activeTaxSetting, setActiveTaxSetting] = useState(null);

  const [invoiceNumber, setInvoiceNumber] = useState(null);
  const [supplierOrderNumber, setSupplierOrderNumber] = useState(null);
  const [notes, setNotes] = useState(null);

  const [adjustedTotal, setAdjustedTotal] = useState(null);
  const [shippingTotal, setShippingTotal] = useState(null);
  const [expectedDate, setExpectedDate] = useState(null);
  const [paymentDate, setPaymentDate] = useState(null);

  const [submitted, setSubmitted] = useState(false);

  const [showAddSupplierAssignmentModal, setShowAddSupplierAssignmentModal] = useState(false);
  const [modalProductId, setModalProductId] = useState(null);
  const [modalVariationId, setModalVariationId] = useState(null);
  const [modalOptions, setModalOptions] = useState(null);
  const [modalProductName, setModalProductName] = useState(null);
  const [modalType, setModalType] = useState(null);
  const [modalAssignment, setModalAssignment] = useState(null);

  const [warnings, setWarnings] = useState({ moq: {}, orderMultiple: {} });

  const setOrderLines = () => {
    clearPOLines();

    if(activeSuggestedPurchaseOrder) {
      activeSuggestedPurchaseOrder.suggested_purchase_order_lines.suggested_purchase_order_lines.forEach(lineItem => {
        let relatedProduct = activeSuggestedPurchaseOrder?.suggested_purchase_order_lines?.related_product_data?.find( prod => parseInt(prod.id) === parseInt(lineItem.product_id))

        let lineObject = {
          imageUrl: lineItem.item_image_url || relatedProduct?.smallThumbnailUrl,
          minimumOrder: lineItem.minimum_order_quantity,
          options: lineItem.item_options,
          productId: parseInt(lineItem.product_id),
          productName: lineItem.item_name,
          name: lineItem.item_name,
          sku: lineItem.item_sku,
          supplier_price: lineItem?.supplier_price || 0.0,
          supplier_sku: lineItem?.supplier_sku,
          upc: lineItem.item_upc,
          variationId: parseInt(lineItem.variation_id) || null
        }

        if(settings?.settings?.pack_quantities) {
          lineObject.packQuantity = lineItem?.pack_quantity;
        }

        addItem(payload, lineObject);

        quantityUpdate(payload, lineItem.recommended_quantity, parseInt(lineItem.product_id) + '/' + (parseInt(lineItem.variation_id) || null));

        let newWarnings = { ...warnings };

        if(parseInt(lineItem?.minimum_order_quantity) > lineItem.recommended_quantity) {
          newWarnings.moq[parseInt(lineItem.product_id) + '/' + (parseInt(lineItem.variation_id) || null)] = `${lineItem.item_name} line quantity below MOQ: ${lineItem?.minimum_order_quantity} vs. ${lineItem.recommended_quantity}`
          setWarnings(newWarnings);
        }
      })
    }
  };

  useEffect(() => {
    clearPOLines();

    loadTaxSettings(payload);
    loadPaymentTerms(payload);
    loadPaymentMethods(payload);
    loadSuppliers(payload);

    loadSuggestedOrder(payload, suggestedOrderId);
  }, []);


  useEffect(() => {
    let newWarnings = { moq: {}, orderMultiple: {} };

    purchaseOrderLines.lineItems.forEach(lineItem => {
      let itemKey = parseInt(lineItem.productId) + '/' + (parseInt(lineItem.variationId) || null);

      if(parseInt(lineItem.minimumOrder) > purchaseOrderLines.lineDetails[itemKey].quantity) {
        newWarnings.moq[itemKey] = `${lineItem.name || lineItem.productName} line quantity below MOQ: ${lineItem.minimumOrder} vs. ${purchaseOrderLines.lineDetails[itemKey].quantity}`
      }

      if(settings?.settings?.order_multiples) {
        if(lineItem.orderMultiple && ((purchaseOrderLines.lineDetails[itemKey].quantity % lineItem.orderMultiple) !== 0)) {
          newWarnings.orderMultiple[parseInt(lineItem.productId) + '/' + (parseInt(lineItem.variationId) || null)] = `${lineItem.name || lineItem.productName} line not divisible by assignment order multiple: ${lineItem.orderMultiple}`
        }
      }
    });

    setWarnings(newWarnings);
  }, [purchaseOrderLines]);

  useEffect(() => {
    if(activeSuggestedPurchaseOrder) {
      if(suppliers.status === 'success') {
        let supplier = suppliers.suppliers.find(sup => sup.id === activeSuggestedPurchaseOrder.supplier_id)
        activateSupplier(supplier);
      }

      setOrderLines();
    }
  }, [activeSuggestedPurchaseOrder])


  useEffect(() => {
    if(activeSuggestedPurchaseOrder && suppliers.status === 'success') {
      console.log('active suggested PO supplier ID');
      console.log(activeSuggestedPurchaseOrder.supplier_id);

      let supplier = suppliers.suppliers.find(sup => sup.id === activeSuggestedPurchaseOrder.supplier_id)
      activateSupplier(supplier);
    }
  }, [suppliers]);

  useEffect(() => {
    if(newPurchaseOrder) { navigate(-1) };
  }, [newPurchaseOrder]);

    const emptyToNull = (value) => {
    console.log(value);

    let emptyOrNull = value;
    
    if(value === '') {
      emptyOrNull = null;
    }

    return emptyOrNull;
  }

  const setPaymentTerm = (paymentTermId) => {
    let paymentTerm = paymentTerms.paymentTerms.find(term => term.id === paymentTermId);
    setActivePaymentTerm(paymentTerm);
  }

  const setPaymentMethod = (paymentMethodId) => {
    let paymentMethod = paymentMethods.paymentMethods.find(method => method.id === paymentMethodId);
    setActivePaymentMethod(paymentMethod);
  }

  const setTaxSetting = (taxSettingId) => {
    let taxSetting = taxSettings.taxSettings.find(tax => tax.id === taxSettingId);
    setActiveTaxSetting(taxSetting);
  }

  const purchaseOrderJson = () => {
    return {
      supplier: activeSupplier,
      shipping_address: 'Ecwid Origin',
      payment_term: activePaymentTerm,
      payment_method: activePaymentMethod,
      invoice_number: invoiceNumber,
      tax_setting: activeTaxSetting,
      supplier_order_number: supplierOrderNumber,
      notes: notes,
      invoice_date: invoiceDate,
      adjusted_total: adjustedTotal,
      shipping_total: shippingTotal || 0.0,
      expected_date: expectedDate,
      payment_due_date: paymentDate
    }
  }

  const purchaseOrderLinesJson = () => {
    let orderLines = [];

    purchaseOrderLines?.lineItems?.forEach(purchaseOrderLine => {
      let key = parseInt(purchaseOrderLine.productId) + '/' + (parseInt(purchaseOrderLine.variationId) || null);
      let lineWithDetails = {...purchaseOrderLine};
      lineWithDetails.line_details = purchaseOrderLines.lineDetails[key];
      orderLines.push(lineWithDetails);
    })

    // console.log(orderLines);

    return orderLines;
  }

  const setFieldValue = (setField, event) => {
    let value = event.target.value;
    setField(value);

    if (value) {
      event.target.parentElement.classList.add("field--filled");
    } else {
      event.target.parentElement.classList.remove("field--filled");
    }
  }

  const setDropdownValue = (setField, value) => {
    setField(value);
  }

  const activateSupplier = (supplier) => {
    setActiveSupplier(supplier);
    setActivePaymentTerm(paymentTerms.paymentTerms.find(term => term.id === supplier.payment_terms_id));
    setActivePaymentMethod(paymentMethods.paymentMethods.find(method => method.id === supplier.payment_method_id));
    setActiveTaxSetting(taxSettings.taxSettings.find(setting => setting.id === supplier.tax_setting_id));

    if(supplier.shipping_days) {
      let expected = new Date();

      expected.setDate(expected.getDate() + parseInt(supplier.shipping_days));

      const yyyy = expected.getFullYear();
      let mm = expected.getMonth() + 1; // months start at 0
      let dd = expected.getDate();

      if (dd < 10) dd = '0' + dd;
      if (mm < 10) mm = '0' + mm;

      let formattedExpected = yyyy + '-' + mm + '-' + dd;

      setExpectedDate(formattedExpected);
    }
  }

  const handleSubmit = () => {
    setSubmitted(true);
    markSuggestionComplete(payload, suggestedOrderId);
    addPurchaseOrder(payload, purchaseOrderJson(), purchaseOrderLinesJson());
  }

  const validPO = () => {
    let block = !(activePaymentTerm && activePaymentMethod && activeTaxSetting && expectedDate && paymentDate && invoiceDate && (purchaseOrderLines?.lineItems.length > 0))

    if(settings?.settings?.warnings_block) {
      if (Object.keys(warnings.moq).length > 0 || Object.keys(warnings.orderMultiple).length > 0) {
        block = true;
      }
    }

    return block;
  }

  const todayForm = () => {
    const today = new Date();
    const yyyy = today.getFullYear();
    let mm = today.getMonth() + 1; // months start at 0
    let dd = today.getDate();

    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;

    let todayDate = `${yyyy}-${mm}-${dd}`;

    return todayDate;
  }

  const [invoiceDate, setInvoiceDate] = useState(todayForm());

  const setInvoiceD = (value) => {
    setInvoiceDate(value);
  }

  const nextYear = () => {
    const today = new Date();
    const yyyy = today.getFullYear() + 1;
    let mm = today.getMonth() + 1; // months start at 0
    let dd = today.getDate();

    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;

    let next = mm + '/' + dd + '/' + yyyy;

    return next;
  }

  return(
    <>
      <PageHeader stripeBackground='#5bc6cc' helpLink="ecwid/create-and-update-purchase-orders-2/" />

      <div className="settings-page cf">
        <div className="settings-page__header">
          <div className="named-area">
            <div className="named-area__header">
              <div className="named-area__titles">
                <div className="named-area__title">Create Suggested Purchase Order</div>
              </div>
              <div className="named-area__description">
                <p>From this page, you can create a purchase order from your suggested purchase order.</p>
                <p>Set payment terms, a payment method and tax settings from their respective dropdowns. If options are missing, you can add them by going to the <Link to="/settings">Settings page</Link>.</p>
                <p>
                  Add product/variant lines to this purchase order by selecting from a paginated set of products assigned to the selected supplier in the "List Supplier Assignments" tab, by searching your store in the "Search Products" tab, or by scanning barcodes in the "Scan Barcodes" tab.
                  If products are missing from this supplier, you can add them by going to the <Link to="/assignments">Supplier Assignments page</Link>.
                </p>
                <p>Add additional information and notes in the "Totals, Adjustments and Dates" panel, then create the purchase order by clicking the "Create Purchase Order" button.</p>

              </div>
            </div>

            <div className="named-area__body">
              <div className="a-card-stack">
                
                <div className="a-card a-card--normal">
                  <div className="a-card__paddings">
                    <h3>Create Suggested Purchase Order</h3>
                    
                      <div className="flex-container">
                        <div className="flex-1">
                          { activeSupplier && 
                            <>
                              <h3>Supplier: { activeSupplier.supplier_name }</h3>
                              <h4>Address</h4>
                              <p>{activeSupplier.address.company ? `${activeSupplier.address.company} - ` : ''}{activeSupplier.address.first_name} {activeSupplier.address.last_name}
                              <br/>
                              {activeSupplier.address.street_1}
                              { activeSupplier.address.street_2 &&
                                <>
                                  <br/>
                                  {activeSupplier.address.street_2}
                                </>
                              }
                              <br/>
                              {activeSupplier.address.city}, {activeSupplier.address.state}
                              <br/>
                              {activeSupplier.address.zip}</p>
                            </>
                          }
                        </div>
                        
                          <div className="flex-1 text-right left-15">
                            { accounts.status === 'success' && 
                              <>
                                <h3>Ship To Address</h3>
                                <p>{accounts.store.store_details.shipping.shippingOrigin.companyName ? `${accounts.store.store_details.shipping.shippingOrigin.companyName}` : ''}
                                <br/>
                                {accounts.store.store_details.shipping.shippingOrigin.street}
                                <br/>
                                {accounts.store.store_details.shipping.shippingOrigin.city}, {accounts.store.store_details.shipping.shippingOrigin.stateOrProvinceCode}
                                <br/>
                                {accounts.store.store_details.shipping.shippingOrigin.postalCode}</p>
                              </>
                            }
                          </div>
                      </div>




                  </div>
                </div>


                <div className="a-card a-card--normal">
                  <div className="a-card__paddings">

                    <h3>Purchase Order Information</h3>

                    { paymentTerms.status === 'success' &&
                      <div className="flex-1">
                        <h4>Payment Terms</h4>

                        <div className="fieldset fieldset--select fieldset__half-width">
                          <div className="field field--medium">
                            <label className="field__label">Payment Terms</label>
                            <select className="field__select" onChange={(e) => setPaymentTerm(e.target.value)}>
                              <option hidden disabled selected value></option>
                              { paymentTerms.paymentTerms.map(paymentTerm => 
                                <option value={paymentTerm.id} key={paymentTerm.id}>{paymentTerm.term_name}</option>
                              )}

                            </select>

                            <div className="field__placeholder">{activePaymentTerm?.term_name || "Payment Terms"}</div>
                          </div>
                        </div>

                      </div>
                    }

                    { paymentMethods.status === 'success' &&
                      <div className="flex-1">
                        <h4>Payment Method</h4>

                        <div className="fieldset fieldset--select fieldset__half-width">
                          <div className="field field--medium">
                            <label className="field__label">Payment Method</label>
                            <select className="field__select" onChange={(e) => setPaymentMethod(e.target.value)}>
                              <option hidden disabled selected value></option>
                              { paymentMethods.paymentMethods.map(paymentMethod => 
                                <option value={paymentMethod.id} key={paymentMethod.id}>{paymentMethod.method_name}</option>
                              )}

                            </select>

                            <div className="field__placeholder">{activePaymentMethod?.method_name || "Payment Method"}</div>
                          </div>
                        </div>

                      </div>
                    }

                    { taxSettings.status === 'success' &&
                      <div className="flex-1">
                        <h4>Tax Settings</h4>

                        <div className="fieldset fieldset--select fieldset__half-width">
                          <div className="field field--medium">
                            <label className="field__label">Tax Setting</label>
                            <select className="field__select" onChange={(e) => setTaxSetting(e.target.value)}>
                              <option hidden disabled selected value></option>
                              { taxSettings.taxSettings.map(taxSetting => 
                                <option value={taxSetting.id} key={taxSetting.id}>{taxSetting.tax_name}</option>
                              )}

                            </select>

                            <div className="field__placeholder">{activeTaxSetting?.tax_name || "Tax Setting"}</div>
                          </div>
                        </div>

                      </div>
                    }

                    <hr/>

                    <div className="fieldset">
                      <div className="field field--medium">
                        <span className="fieldset__svg-icon"></span>
                        <label className="field__label">{`${settings.settings['invoice_number_override'] || "Invoice Number"}`}</label>
                        <input id="invoice_number" type="text" className="field__input" tabindex="4" maxlength="64" value={invoiceNumber} onChange={(e) => setFieldValue(setInvoiceNumber, e)} />
                        <div className="field__placeholder">{`${settings.settings['invoice_number_override'] || "Invoice Number"}`}</div>
                        <span className="field-state--success"><svg xmlns="http://www.w3.org/2000/svg" width="26px" height="26px" viewBox="0 0 26 26" focusable="false"><path d="M5 12l5.02 4.9L21.15 4c.65-.66 1.71-.66 2.36 0 .65.67.65 1.74 0 2.4l-12.3 14.1c-.33.33-.76.5-1.18.5-.43 0-.86-.17-1.18-.5l-6.21-6.1c-.65-.66-.65-1.74 0-2.41.65-.65 1.71-.65 2.36.01z"></path></svg></span>
                        <span className="field-state--close"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 16 16" enable-background="new 0 0 16 16" xml:space="preserve" focusable="false"><path d="M15.6,15.5c-0.53,0.53-1.38,0.53-1.91,0L8.05,9.87L2.31,15.6c-0.53,0.53-1.38,0.53-1.91,0c-0.53-0.53-0.53-1.38,0-1.9l5.65-5.64L0.4,2.4c-0.53-0.53-0.53-1.38,0-1.91c0.53-0.53,1.38-0.53,1.91,0l5.64,5.63l5.74-5.73c0.53-0.53,1.38-0.53,1.91,0c0.53,0.53,0.53,1.38,0,1.91L9.94,7.94l5.66,5.65C16.12,14.12,16.12,14.97,15.6,15.5z"></path></svg></span>
                      </div>
                    </div>

                    <div className="fieldset left-15">
                      <div className="field field--medium">
                        <span className="fieldset__svg-icon"></span>
                        <label className="field__label">{`${settings.settings['purchase_order_number_override'] || "Purchase Order Number"}`}</label>
                        <input id="supplier_order_number" type="text" className="field__input" tabindex="4" maxlength="64" value={supplierOrderNumber} onChange={(e) => setFieldValue(setSupplierOrderNumber, e)} />
                        <div className="field__placeholder">{`${settings.settings['purchase_order_number_override'] || "Purchase Order Number"}`}</div>
                        <span className="field-state--success"><svg xmlns="http://www.w3.org/2000/svg" width="26px" height="26px" viewBox="0 0 26 26" focusable="false"><path d="M5 12l5.02 4.9L21.15 4c.65-.66 1.71-.66 2.36 0 .65.67.65 1.74 0 2.4l-12.3 14.1c-.33.33-.76.5-1.18.5-.43 0-.86-.17-1.18-.5l-6.21-6.1c-.65-.66-.65-1.74 0-2.41.65-.65 1.71-.65 2.36.01z"></path></svg></span>
                        <span className="field-state--close"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 16 16" enable-background="new 0 0 16 16" xml:space="preserve" focusable="false"><path d="M15.6,15.5c-0.53,0.53-1.38,0.53-1.91,0L8.05,9.87L2.31,15.6c-0.53,0.53-1.38,0.53-1.91,0c-0.53-0.53-0.53-1.38,0-1.9l5.65-5.64L0.4,2.4c-0.53-0.53-0.53-1.38,0-1.91c0.53-0.53,1.38-0.53,1.91,0l5.64,5.63l5.74-5.73c0.53-0.53,1.38-0.53,1.91,0c0.53,0.53,0.53,1.38,0,1.91L9.94,7.94l5.66,5.65C16.12,14.12,16.12,14.97,15.6,15.5z"></path></svg></span>
                      </div>
                    </div>

                  </div>
                </div>                

              </div>
            </div>
          </div>


          <div className="named-area">
            <div className="named-area__header">
              <div className="named-area__titles">
                <div className="named-area__title">Purchase Order Lines Settings</div>
              </div>
              <div className="named-area__description">
                
              </div>
            </div>

            <div className="named-area__body">

              <div className="a-card-stack">

                <div className="a-card a-card--normal">
                  <div className="a-card__paddings">
                    { purchaseOrderLines?.lineItems?.map(purchaseOrderLine => 
                      <PurchaseOrderLine
                        purchaseOrderLine={purchaseOrderLine}
                        purchaseOrderType={'restock'}
                        
                        setModalProductId={setModalProductId}
                        setModalVariationId={setModalVariationId}
                        setModalOptions={setModalOptions}
                        setModalProductName={setModalProductName}
                        setModalType={setModalType}
                        setModalAssignment={setModalAssignment}
                        setShowAddSupplierAssignmentModal={setShowAddSupplierAssignmentModal}
                        activeSupplier={activeSupplier}
                        showSuggestionLevels={true}
                      />

                    )}
                  </div>
                </div>

              </div>
            </div>
          </div>

          <div className="named-area">
            <div className="named-area__header">
              <div className="named-area__titles">
                <div className="named-area__title">Totals, Adjustments and Dates</div>
              </div>
              <div className="named-area__description">
                
              </div>
            </div>

            <div className="named-area__body">

              <div className="a-card-stack">

                <div className="a-card a-card--normal">
                  <div className="a-card__paddings">


                  <div className="flex-container">
                    <div className="flex-1">
                      <h4>Significant Dates</h4>

                      <div className="fieldset fieldset__half-width">
                        <div className="field field--medium field--filled">
                          <span className="fieldset__svg-icon"></span>
                          <label className="field__label">Invoice Date</label>
                          <input
                            type="date"
                            id="invoice_date"
                            value={invoiceDate}
                            min={todayForm()}
                            max={nextYear()}
                            onChange={(e) => setInvoiceDate(emptyToNull(e.target.value))} 
                            className="field__input"
                            onFocus={focus}
                            onBlur={blur}
                          />
                          <div className="field__placeholder">Invoice Date</div>
                          <span className="field-state--success"><svg xmlns="http://www.w3.org/2000/svg" width="26px" height="26px" viewBox="0 0 26 26" focusable="false"><path d="M5 12l5.02 4.9L21.15 4c.65-.66 1.71-.66 2.36 0 .65.67.65 1.74 0 2.4l-12.3 14.1c-.33.33-.76.5-1.18.5-.43 0-.86-.17-1.18-.5l-6.21-6.1c-.65-.66-.65-1.74 0-2.41.65-.65 1.71-.65 2.36.01z"></path></svg></span>
                          <span className="field-state--close"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 16 16" enable-background="new 0 0 16 16" xml:space="preserve" focusable="false"><path d="M15.6,15.5c-0.53,0.53-1.38,0.53-1.91,0L8.05,9.87L2.31,15.6c-0.53,0.53-1.38,0.53-1.91,0c-0.53-0.53-0.53-1.38,0-1.9l5.65-5.64L0.4,2.4c-0.53-0.53-0.53-1.38,0-1.91c0.53-0.53,1.38-0.53,1.91,0l5.64,5.63l5.74-5.73c0.53-0.53,1.38-0.53,1.91,0c0.53,0.53,0.53,1.38,0,1.91L9.94,7.94l5.66,5.65C16.12,14.12,16.12,14.97,15.6,15.5z"></path></svg></span>
                        </div>
                        <div className="field__error" aria-hidden="true" style={{ display: 'none' }}></div>

                        <br/>
                        <br/>

                        <div className="field field--medium field--filled">
                          <span className="fieldset__svg-icon"></span>
                          <label className="field__label">Expected Date</label>
                          <input
                            type="date"
                            id="expected_date"
                            value={expectedDate}
                            min={todayForm()}
                            max={nextYear()}
                            onChange={(e) => setExpectedDate(emptyToNull(e.target.value))} 
                            className="field__input"
                            onFocus={focus}
                            onBlur={blur}
                          />
                          <div className="field__placeholder">Expected Date</div>
                          <span className="field-state--success"><svg xmlns="http://www.w3.org/2000/svg" width="26px" height="26px" viewBox="0 0 26 26" focusable="false"><path d="M5 12l5.02 4.9L21.15 4c.65-.66 1.71-.66 2.36 0 .65.67.65 1.74 0 2.4l-12.3 14.1c-.33.33-.76.5-1.18.5-.43 0-.86-.17-1.18-.5l-6.21-6.1c-.65-.66-.65-1.74 0-2.41.65-.65 1.71-.65 2.36.01z"></path></svg></span>
                          <span className="field-state--close"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 16 16" enable-background="new 0 0 16 16" xml:space="preserve" focusable="false"><path d="M15.6,15.5c-0.53,0.53-1.38,0.53-1.91,0L8.05,9.87L2.31,15.6c-0.53,0.53-1.38,0.53-1.91,0c-0.53-0.53-0.53-1.38,0-1.9l5.65-5.64L0.4,2.4c-0.53-0.53-0.53-1.38,0-1.91c0.53-0.53,1.38-0.53,1.91,0l5.64,5.63l5.74-5.73c0.53-0.53,1.38-0.53,1.91,0c0.53,0.53,0.53,1.38,0,1.91L9.94,7.94l5.66,5.65C16.12,14.12,16.12,14.97,15.6,15.5z"></path></svg></span>
                        </div>
                        <div className="field__error" aria-hidden="true" style={{ display: 'none' }}></div>
                        <br/><br/>


                        <div className="field field--medium field--filled">
                          <span className="fieldset__svg-icon"></span>
                          <label className="field__label">Payment Due Date</label>
                          <input
                            type="date"
                            id="payment_date"
                            value={paymentDate}
                            min={todayForm()}
                            max={nextYear()}
                            onChange={(e) => setPaymentDate(emptyToNull(e.target.value))} 
                            className="field__input"
                            onFocus={focus}
                            onBlur={blur}
                          />
                          <div className="field__placeholder">Payment Due Date</div>
                          <span className="field-state--success"><svg xmlns="http://www.w3.org/2000/svg" width="26px" height="26px" viewBox="0 0 26 26" focusable="false"><path d="M5 12l5.02 4.9L21.15 4c.65-.66 1.71-.66 2.36 0 .65.67.65 1.74 0 2.4l-12.3 14.1c-.33.33-.76.5-1.18.5-.43 0-.86-.17-1.18-.5l-6.21-6.1c-.65-.66-.65-1.74 0-2.41.65-.65 1.71-.65 2.36.01z"></path></svg></span>
                          <span className="field-state--close"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 16 16" enable-background="new 0 0 16 16" xml:space="preserve" focusable="false"><path d="M15.6,15.5c-0.53,0.53-1.38,0.53-1.91,0L8.05,9.87L2.31,15.6c-0.53,0.53-1.38,0.53-1.91,0c-0.53-0.53-0.53-1.38,0-1.9l5.65-5.64L0.4,2.4c-0.53-0.53-0.53-1.38,0-1.91c0.53-0.53,1.38-0.53,1.91,0l5.64,5.63l5.74-5.73c0.53-0.53,1.38-0.53,1.91,0c0.53,0.53,0.53,1.38,0,1.91L9.94,7.94l5.66,5.65C16.12,14.12,16.12,14.97,15.6,15.5z"></path></svg></span>
                        </div>
                        <div className="field__error" aria-hidden="true" style={{ display: 'none' }}></div>
                      </div>
                    </div>

                    <PurchaseOrderTotals
                      purchaseOrderLines={purchaseOrderLines}
                      activeSupplier={activeSupplier}
                      taxSetting={activeTaxSetting}
                      adjustedTotal={adjustedTotal}
                      shippingTotal={shippingTotal}
                      setAdjustedTotal={setAdjustedTotal}
                      setShippingTotal={setShippingTotal}
                    />
                  </div>
                </div>


              </div>
            </div>

          </div>
        </div>



          <div className="named-area">
            <div className="named-area__header">
              <div className="named-area__titles">
                <div className="named-area__title">Finalize Purchase Order</div>
              </div>
              <div className="named-area__description">
                
              </div>
            </div>

            <div className="named-area__body">

              <div className="a-card-stack">
      
                <div className="a-card a-card--normal">
                  <div className="a-card__paddings">
                    { activeSupplier &&
                      <div className="fieldset fieldset--textarea">
                        <div className="field field--filled">
                          <textarea className="field__textarea" value={notes} tabindex="1" maxlength="200" onChange={(e) => setFieldValue(setNotes, e)}></textarea>
                          <div className="field__placeholder">Notes</div>
                        </div>
                      </div>
                    }

                    <button
                      className="btn btn-primary" 
                      onClick={() => handleSubmit()}
                      disabled={validPO() || submitted}
                    >
                      <span className="svg-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9"><path d="M5 4V2.5a.5.5 0 1 0-1 0V4H2.5a.5.5 0 1 0 0 1H4v1.5a.5.5 0 1 0 1 0V5h1.5a.5.5 0 1 0 0-1H5z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M8 1H1v7h7V1zM1 0C.4477 0 0 .4477 0 1v7c0 .5523.4477 1 1 1h7c.5523 0 1-.4477 1-1V1c0-.5523-.4477-1-1-1H1z"/></svg>
                      </span>
                      <span className="gwt-InlineLabel">Create Suggested Purchase Order</span>
                    </button>

                    { activeSupplier && !activePaymentTerm &&
                      <div className="text-small error">Purchase Order Must Specify a Payment Term</div>
                    }
                    { activeSupplier && !activePaymentMethod &&
                      <div className="text-small error">Purchase Order Must Specify a Payment Method</div>
                    }
                    { activeSupplier && !activeTaxSetting &&
                      <div className="text-small error">Purchase Order Must Specify a Tax Setting</div>
                    }
                    { activeSupplier && !invoiceDate &&
                      <div className="text-small error">Purchase Order Must Include an Invoice Date</div>
                    }
                    { activeSupplier && !expectedDate &&
                      <div className="text-small error">Purchase Order Must Include an Expected Date</div>
                    }
                    { activeSupplier && !paymentDate &&
                      <div className="text-small error">Purchase Order Must Include an Expected Payment Date</div>
                    }
                    { activeSupplier && !(purchaseOrderLines?.lineItems.length > 0) &&
                      <div className="text-small error">Purchase Order Must Include Purchase Items</div>
                    }

                    { Object.keys(warnings.moq).map(warningId => 
                      <>
                        <div className="text-small warning">{warnings.moq[warningId]}</div>
                      </>
                      )
                    }

                    { Object.keys(warnings.orderMultiple).map(warningId => 
                      <>
                        <div className="text-small warning">{warnings.orderMultiple[warningId]}</div>
                      </>
                      )
                    }
                  </div>
                </div>

              </div>


            </div>
          </div>



        </div>
      </div>

    </>
  )
}

const mapStateToProps = state => ({
  accounts: state.accounts,
  suppliers: state.suppliers,
  newPurchaseOrder: state.purchaseOrders.newPurchaseOrder,
  taxSettings: state.taxSettings,
  paymentTerms: state.paymentTerms,
  paymentMethods: state.paymentMethods,
  purchaseOrderLines: state.purchaseOrderLines,
  incompleteOrders: state.incompleteOrders,
  activeSuggestedPurchaseOrder: state.suggestedPurchaseOrders.activeSuggestedPurchaseOrder,
  products: state.products,
  settings: state.settings,
});

const mapDispatchToProps = (dispatch) => ({
  loadTaxSettings: (payload) => dispatch(taxSettingsIndex(payload)),
  loadPaymentTerms: (payload) => dispatch(paymentTermsIndex(payload)),
  loadPaymentMethods: (payload) => dispatch(paymentMethodsIndex(payload)),
  loadSuppliers: (payload) => dispatch(suppliersIndex(payload)),
  addPurchaseOrder: (payload, purchaseOrderJson, purchaseOrderLinesJson) => dispatch(purchaseOrdersCreate(payload, purchaseOrderJson, purchaseOrderLinesJson, 'restock')),
  markSuggestionComplete: (payload, suggestedOrderId) => dispatch(markComplete(payload, suggestedOrderId)),
  clearPOLines: () => dispatch(reset()),
  loadSuggestedOrder: (payload, suggestedOrderId) => dispatch(findSuggestedPurchaseOrder(payload, suggestedOrderId)),

  quantityUpdate: (payload, itemData, itemKey) => dispatch(purchaseOrderUpdateQuantity(payload, itemData, itemKey)),
  addItem: (payload, itemData) => dispatch(purchaseOrderAddItem(payload, itemData)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewSuggestedPurchaseOrderForm);
